if (!customElements.get('wlsn-product-variants')) {
  class WLSNProductVariants extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        loadingState: 'wlsn-loading-state',
      };

      this.boundMethods = {
        onChange: this._onChange.bind(this),
        onPageUpdated: this._onPageUpdated.bind(this),
      };
    }

    connectedCallback() {
      this.addEventListener('change', this.boundMethods.onChange);
      window.addEventListener('wlsn:page:updated', this.boundMethods.onPageUpdated);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.boundMethods.onChange);
      window.removeEventListener('wlsn:page:updated', this.boundMethods.onPageUpdated);
    }

    /**
     * Selected option value IDs in product option order (for ?option_values=).
     * @returns {string[]|null}
     */
    _getSelectedOptionValueIds() {
      const groups = [...this.querySelectorAll('[data-wlsn-option-index]')];
      if (!groups.length) return null;

      groups.sort(
        (a, b) =>
          Number(a.getAttribute('data-wlsn-option-index')) - Number(b.getAttribute('data-wlsn-option-index')),
      );

      const ids = groups.map((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      if (ids.some((id) => id == null || id === '')) return null;
      return ids;
    }

    /**
     * @returns {string|null}
     */
    _buildOptionValuesUrl() {
      const productUrl = this.getAttribute('data-product-url');
      const ids = this._getSelectedOptionValueIds();
      if (!productUrl || !ids) return null;

      const url = new URL(productUrl, window.location.href);
      url.searchParams.set('option_values', ids.join(','));
      return url.toString();
    }

    /**
     * @returns {boolean}
     */
    _shouldInterceptNavigation() {
      const buybox = this.closest('wlsn-buybox');
      const templateName = buybox?.getAttribute('data-template-name') || '';
      const isProductPage =
        buybox?.getAttribute('data-is-product-page') === 'true' &&
        window.location.pathname.startsWith('/products/');
      return isProductPage || (Boolean(templateName) && templateName !== 'none');
    }

    _onChange(event) {
      const input = event.target;
      if (!input || input.type !== 'radio' || !input.closest('[data-wlsn-option-index]')) return;

      const url = this._buildOptionValuesUrl();
      if (!url) return;

      if (!this._shouldInterceptNavigation()) {
        window.location.assign(url);
        return;
      }

      this.classList.add(this.classes.loadingState);

      if (window.WLSNHelpers?.triggerEvent) {
        window.WLSNHelpers.triggerEvent(this, 'wlsn:buybox:product-variant-change', { url });
      }
    }

    _onPageUpdated() {
      this.classList.remove(this.classes.loadingState);
    }
  }

  customElements.define('wlsn-product-variants', WLSNProductVariants);
}
